import { render, staticRenderFns } from "./ShopConfig.vue?vue&type=template&id=37493ebc&scoped=true&"
import script from "./ShopConfig.vue?vue&type=script&lang=js&"
export * from "./ShopConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShopConfig.vue?vue&type=style&index=0&id=37493ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37493ebc",
  null
  
)

export default component.exports